export default __webpack_public_path__ + "static/media/370.a3d21dc0.gif";